<template>
  <create-task tool="publisher"></create-task>
</template>

<script>
import CreateTask from '../ToolsTemplates/CreateTask';

export default {
  components: {
    'create-task': CreateTask,
  },
};
</script>

<style></style>
